// Loyalty Page Controller
var storefrontApp = angular.module("storefrontApp");

storefrontApp.controller(
    'LoyaltyController', [
    '$scope',
    '$sce',
    'mainService',
    function ($scope, $sce, mainService) {

        // Function to trust HTML content for ng-bind-html
        $scope.trustAsHtml = function(html) {
            return $sce.trustAsHtml(html);
        };

        // Initialize loyalty content
        $scope.loyaltyContent = {};

        // Fetch loyalty content from API
        mainService.getLoyaltyContent()
            .then(function(response) {
                $scope.loyaltyContent = response.data;
            })
            .catch(function(error) {
                console.error('Error fetching loyalty content:', error);
            });

        // FAQ accordion functionality
        $scope.toggleFaq = function (index) {
            $scope.activeFaqIndex = $scope.activeFaqIndex === index ? -1 : index;
        };

        $scope.activeFaqIndex = 0;
    }]
);

// Add a custom directive to handle HTML content
storefrontApp.directive('bindUnsafeHtml', ['$compile', function ($compile) {
    return function(scope, element, attrs) {
        scope.$watch(
            function(scope) {
                return scope.$eval(attrs.bindUnsafeHtml);
            },
            function(value) {
                element.html(value);
                $compile(element.contents())(scope);
            }
        );
    };
}]);
